jQuery(function($) {
    $(document).ready(function () {
        const {__, _x, _n, _nx} = wp.i18n;

        // Parking form widget - 2h minimum lead time, matches inc/parking.php::check_validity().
        const widgetForm = $('#parking_widget_form');

        if (widgetForm.length > 0) {
            moment.locale('en-gb');

            // On a successful submit we deliberately leave the overlay showing
            // and navigate away to the booking platform (see submitHandler
            // below). If the visitor then hits "back", the browser can restore
            // this page from bfcache exactly as it was left - overlay stuck on
            // top, submit button disabled. Clear it on that restore.
            $(window).on('pageshow', function (e) {
                if (e.originalEvent && e.originalEvent.persisted) {
                    $(".parking_loading_overlay").removeClass("active");
                    $("body").css("overflow", "visible");
                    widgetForm.find('button[type=submit]').prop('disabled', false);
                }
            });

            // Mobile only: pin the widget exactly 34px below the hero text
            // card's actual bottom edge. Computed from live measurements
            // (not a fixed CSS margin) because the card's height varies with
            // its content/wrapping across devices - a static offset drifts.
            const MOBILE_BREAKPOINT = 767;

            function positionWidgetBelowHeroCard() {
                const $widget = $('.parking-widget');
                const $heroCard = $('.hero__text-card--left');

                if (!$widget.length || !$heroCard.length) {
                    return;
                }

                if (window.innerWidth > MOBILE_BREAKPOINT) {
                    $widget.css('margin-top', '');
                    return;
                }

                // margin-top (not top) - `top` on a position:relative element
                // only shifts it visually and leaves its original slot reserved
                // in the flow, so whatever follows leaves a gap the size of the
                // shift. margin-top actually pushes the flow, no gap left behind.
                $widget.css('margin-top', '0px'); // neutral baseline to measure from
                const heroBottom = $heroCard[0].getBoundingClientRect().bottom;
                const widgetTop = $widget[0].getBoundingClientRect().top;

                $widget.css('margin-top', (heroBottom + 34 - widgetTop) + 'px');
            }

            positionWidgetBelowHeroCard();
            $(window).on('load resize orientationchange', positionWidgetBelowHeroCard);

            // Allow picking "today" only if there are at least 2 hours left in the day
            // (matches the 2h-lead-time rule enforced below and server-side)
            function dynamicMinStartDays() {
                var now = new Date();
                var hoursLeft = 24 - now.getHours();
                return (hoursLeft >= 2) ? 0 : 1; // 0 = today, 1 = tomorrow
            }

            // Set end-date's minimal allowed date based on start date + start time (+2h rule)
            function setEndMinDateFrom(startDateStr, startTimeVal) {
                var m = moment(startDateStr, 'DD/MM/YYYY');
                var startHour = parseInt(startTimeVal, 10) || 0;

                if ((startHour + 2) >= 24) {
                    m = m.clone().add(1, 'day');
                }

                $("#p_end_date").datepicker("option", "minDate", m.toDate());
            }

            // --- Start Date ---
            $("#p_start_date").datepicker({
                changeYear: true,
                changeMonth: true,
                numberOfMonths: 1,
                minDate: dynamicMinStartDays(),
                maxDate: "+9M",
                dateFormat: 'dd/mm/yy',
                yearRange: "-0:+1",
                firstDay: 1,

                onSelect: function (selectedDateStr) {
                    var chosenStartTime = parseInt($('#p_start_time').val(), 10) || 0;
                    $('#p_start_time').val('');
                    setEndMinDateFrom(selectedDateStr, chosenStartTime);
                },

                onChangeMonthYear: function (year, month, inst) {
                    var firstOfMonth = moment({year: year, month: month - 1, day: 1});
                    if (!$("#p_start_date").val()) {
                        $("#p_start_date").datepicker('setDate', firstOfMonth.toDate());
                    }
                }
            });

            // --- End Date ---
            $("#p_end_date").datepicker({
                changeYear: true,
                changeMonth: true,
                numberOfMonths: 1,
                minDate: dynamicMinStartDays(),
                maxDate: "+9M",
                dateFormat: 'dd/mm/yy',
                yearRange: "-0:+1",
                firstDay: 1,

                onSelect: function (selectedDateStr) {
                    $("#p_end_time").val('');
                    $("#p_start_date").datepicker("option", "maxDate", moment(selectedDateStr, 'DD/MM/YYYY').toDate());
                },

                onChangeMonthYear: function (year, month, inst) {
                    var firstOfMonth = moment({year: year, month: month - 1, day: 1});
                    if (!$("#p_end_date").val()) {
                        $("#p_end_date").datepicker('setDate', firstOfMonth.toDate());
                    }
                }
            });

            // --- Initial sync (in case there are preset values) ---
            (function bootstrapSync() {
                var startVal = $("#p_start_date").val();
                var startTimeVal = $('#p_start_time').val();
                if (startVal) {
                    setEndMinDateFrom(startVal, startTimeVal);
                } else {
                    $("#p_end_date").datepicker("option", "minDate", dynamicMinStartDays());
                }
            })();

            // If start time changes after picking a date, re-apply the +2h rule for end date
            $(document).on('change', '#p_start_time', function () {
                var startVal = $("#p_start_date").val();
                if (startVal) {
                    setEndMinDateFrom(startVal, this.value);
                }
            });

            $.validator.addMethod("regexDateFormat", function (value, element, regexp) {
                const re = new RegExp(regexp);
                return this.optional(element) || re.test(value);
            }, __('Wrong date format', 'sofia-airport'));

            $.validator.addMethod("regexTimeFormat", function (value, element) {
                return this.optional(element) || /^([0-9]{2}:[0-9]{2})$/i.test(value);
            }, __('Wrong time format', 'sofia-airport'));

            $.validator.addMethod("regexLicensePlate", function (value, element) {
                return this.optional(element) || /^[A-Za-z0-9]+$/i.test(value);
            }, __('License plate should contain only numbers and latin letters.', 'sofia-airport'));

            const parkingStartTime = widgetForm.find('#p_start_time');
            const parkingEndTime = widgetForm.find('#p_end_time');

            // -- compute current hour (e.g. 15 if it's 15:34)
            const now = new Date();
            let hournow = now.getHours();
            let currentMinutes = now.getMinutes();
            if (currentMinutes > 0) {
                hournow++;
            }
            const currentHour = hournow;

            parkingStartTime.timepicker({
                timeFormat: 'HH:mm',
                interval: 60,
                minTime: '00:00',
                maxTime: '23:45',
                dynamic: false,
                dropdown: true,
                scrollbar: true
            });

            parkingEndTime.timepicker({
                timeFormat: 'HH:mm',
                interval: 60,
                minTime: "00:00",
                maxTime: '23:45',
                dynamic: false,
                dropdown: true,
                scrollbar: true
            });

            // Helper: check if selected date is today
            function isSelectedToday() {
                const val = $('#p_start_date').val(); // e.g. "01/09/2025"
                if (!val) return false;

                const parts = val.split('/'); // ["01","09","2025"]
                if (parts.length !== 3) return false;

                const [dd, mm, yyyy] = parts.map(p => parseInt(p, 10));
                const picked = new Date(yyyy, mm - 1, dd);
                const today = new Date();

                return picked.getFullYear() === today.getFullYear() &&
                    picked.getMonth() === today.getMonth() &&
                    picked.getDate() === today.getDate();
            }

            // --- HARD DISABLE past slots after the dropdown gets rendered ---
            function hardDisablePastSlots() {
                setTimeout(function () {
                    // if NOT today -> cleanup and bail
                    if (!isSelectedToday()) {
                        let chosenDate = $('#p_start_date').val();
                        let chosenMoment = moment(chosenDate, 'DD/MM/YYYY');
                        let nowMoment = moment();
                        let tomorrowMoment = moment().add(1, 'day').startOf('day');

                        if (chosenMoment.format('YYYYMMDD') == tomorrowMoment.format('YYYYMMDD')) {
                            let hoursUntilTomorrow = tomorrowMoment.diff(nowMoment, 'hours', true);

                            if (hoursUntilTomorrow < 2) {
                                let targetTime = nowMoment.clone().add(2, 'hours');
                                if (targetTime.minutes() > 0 || targetTime.seconds() > 0 || targetTime.milliseconds() > 0) {
                                    targetTime = targetTime.add(1, 'hour').startOf('hour');
                                } else {
                                    targetTime = targetTime.startOf('hour');
                                }
                                let targetHour = targetTime.hours();

                                $('.ui-timepicker-viewport .ui-menu-item > a').each(function () {
                                    const $a = $(this);
                                    const label = $a.text().trim();
                                    const hour = parseInt(label.slice(0, 2), 10);
                                    if (hour < targetHour) {
                                        $a.addClass('tp-disabled')
                                            .attr('aria-disabled', 'true')
                                            .attr('tabindex', '-1')
                                            .off('.tpBlock')
                                            .on('click.tpBlock mousedown.tpBlock keydown.tpBlock', function (e) {
                                                e.preventDefault();
                                                e.stopImmediatePropagation();
                                                return false;
                                            });
                                        $a.closest('li').attr('aria-disabled', 'true');
                                    }
                                });
                            } else {
                                $('.ui-timepicker-viewport .ui-menu-item > a')
                                    .removeClass('tp-disabled')
                                    .removeAttr('aria-disabled tabindex')
                                    .off('.tpBlock')
                                    .closest('li').removeAttr('aria-disabled');
                            }
                            return;
                        } else {
                            $('.ui-timepicker-viewport .ui-menu-item > a')
                                .removeClass('tp-disabled')
                                .removeAttr('aria-disabled tabindex')
                                .off('.tpBlock')
                                .closest('li').removeAttr('aria-disabled');
                            return;
                        }
                    }

                    // today -> apply hard disable for past hours
                    $('.ui-timepicker-viewport .ui-menu-item > a').each(function () {
                        const $a = $(this);
                        const label = $a.text().trim();
                        const hour = parseInt(label.slice(0, 2), 10);
                        if (hour < currentHour + 2) {
                            $a.addClass('tp-disabled')
                                .attr('aria-disabled', 'true')
                                .attr('tabindex', '-1')
                                .off('.tpBlock')
                                .on('click.tpBlock mousedown.tpBlock keydown.tpBlock', function (e) {
                                    e.preventDefault();
                                    e.stopImmediatePropagation();
                                    return false;
                                });
                            $a.closest('li').attr('aria-disabled', 'true');
                        }
                    });
                }, 0);
            }

            // Re-check on date change (and cleanup if not today)
            $('#p_start_date').on('change', function () {
                $('.ui-timepicker-viewport .ui-menu-item > a')
                    .removeClass('tp-disabled')
                    .removeAttr('aria-disabled tabindex')
                    .off('.tpBlock')
                    .closest('li').removeAttr('aria-disabled');

                hardDisablePastSlots();
            });

            parkingStartTime.on('show.timepicker', hardDisablePastSlots);
            parkingStartTime.on('click focus', hardDisablePastSlots);

            function widgetParseDateTime(dateStr, timeStr) {
                return moment(dateStr + ' ' + timeStr, 'DD/MM/YYYY HH:mm');
            }

            // Reserved error slot per field; Arriving/Leaving share one slot per group.
            const fieldErrorSlot = {
                p_start_date: '#parking_widget_error_start',
                p_start_time: '#parking_widget_error_start',
                p_end_date: '#parking_widget_error_end',
                p_end_time: '#parking_widget_error_end',
                license_plate: '#parking_widget_error_plate'
            };

            widgetForm.validate({
                rules: {
                    p_start_date: {
                        required: true,
                        regexDateFormat: /\d{1,2}[^\d]\d{1,2}[^\d]\d{4,4}/gi
                    },
                    p_start_time: {
                        required: true,
                        regexTimeFormat: true
                    },
                    p_end_date: {
                        required: true,
                        regexDateFormat: /\d{1,2}[^\d]\d{1,2}[^\d]\d{4,4}/gi
                    },
                    p_end_time: {
                        required: true,
                        regexTimeFormat: true
                    },
                    license_plate: {
                        required: true,
                        regexLicensePlate: true
                    }
                },
                errorPlacement: function (error, element) {
                    const slot = fieldErrorSlot[element.attr('name')];
                    error.appendTo(slot ? $(slot) : element.parent());
                },
                submitHandler: function (form) {
                    const startDate = $('#p_start_date').val();
                    const startTime = $('#p_start_time').val();
                    const endDate = $('#p_end_date').val();
                    const endTime = $('#p_end_time').val();
                    const licensePlate = $('#license_plate').val().trim().toUpperCase();

                    const $box = $('#parking_widget_response');
                    const $errorStart = $('#parking_widget_error_start');
                    const $errorEnd = $('#parking_widget_error_end');
                    $box.text('');
                    $errorStart.empty();
                    $errorEnd.empty();

                    // Span wrapper so field-error CSS can absolutely position it, no flow-height shift.
                    function showFieldError($slot, message) {
                        $slot.html('<span class="parking-widget__field-error-text">' + message + '</span>');
                    }

                    // Cross-field checks jQuery Validate's rules above don't cover.
                    const start = widgetParseDateTime(startDate, startTime);
                    const end = widgetParseDateTime(endDate, endTime);
                    const nowMoment = moment();

                    if (!end.isAfter(start)) {
                        showFieldError($errorEnd, __('Leaving must be after arriving.', 'sofia-airport'));
                        return;
                    }

                    if (end.diff(start, 'hours', true) < 8) {
                        showFieldError($errorEnd, __('The minimum booking time is 8 hours.', 'sofia-airport'));
                        return;
                    }

                    if (start.diff(nowMoment, 'hours', true) < 2) {
                        showFieldError($errorStart, __('Your start datetime needs to be at least 2h from now.', 'sofia-airport'));
                        return;
                    }

                    widgetForm.find('button[type=submit]').prop('disabled', true);

                    $(".parking_loading_overlay").addClass("active");
                    $("body").css("overflow", "hidden");

                    $.ajax({
                        type: 'POST',
                        url: '/wp-admin/admin-ajax.php',
                        dataType: 'JSON',
                        data: {
                            action: 'parking_request_booking',
                            nonce: SofiaAirportParkinForm.nonce,
                            data: {
                                p_start_date: startDate,
                                p_start_time: startTime,
                                p_end_date: endDate,
                                p_end_time: endTime,
                                license_plate: licensePlate,
                            }
                        },
                        success: function (resp) {
                            widgetForm.find('button[type=submit]').prop('disabled', false);

                            if (resp.success === false) {
                                $box.text(resp.data || __('Something went wrong.', 'sofia-airport'));
                                $(".parking_loading_overlay").removeClass("active");
                                $("body").css("overflow", "visible");
                                return;
                            }

                            window.location.href = SofiaAirportParkinForm.stepTwoUrl + '?data=' + encodeURIComponent(resp.data.token);
                            // overlay left active on purpose - page is navigating away.
                        },
                        error: function (jqXHR) {
                            widgetForm.find('button[type=submit]').prop('disabled', false);
                            $(".parking_loading_overlay").removeClass("active");
                            $("body").css("overflow", "visible");

                            var reason = jqXHR && jqXHR.responseJSON && jqXHR.responseJSON.data;
                            if (reason) {
                                $box.text(reason);
                            } else if (jqXHR && jqXHR.status === 429) {
                                $box.text(__('Too many requests. Please try again in a minute.', 'sofia-airport'));
                            } else {
                                $box.text(__('Something went wrong.', 'sofia-airport') + (jqXHR && jqXHR.status ? ' (HTTP ' + jqXHR.status + ')' : ''));
                            }
                        }
                    });
                }
            });
        }
    });
});
